import { CatchAPIServiceStatement, MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";
class StatementService {
  DoGetStatementActiveDetail(salaryId: number, employeeId: number, merchantId: number) {
    const _input = {
      merchantId: merchantId,
      data: { salaryId: salaryId, employeeId: employeeId },
    };
    return service.peakPayrollAPI
      .post("/api/Salary/GetStatementActiveDetail", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIServiceStatement(err.response));
  }
  DoGetStatementActiveDetailByPasscode(salaryId: number, employeeId: number, merchantId: number, passcode: string) {
    const _input = {
      merchantId: merchantId,
      data: { salaryId: salaryId, employeeId: employeeId, passcode: passcode },
    };
    return service.peakPayrollAPI
      .post("/api/Salary/GetStatementActiveDetailByPasscode", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIServiceStatement(err.response));
  }
  DoCreateStatement(salaryId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: salaryId,
    };
    return service.peakPayrollAPI
      .post("/api/Salary/CreateStatement", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIServiceStatement(err.response));
  }
  DoUpdateStatement(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        salaryId: input.salaryId,
        employeeId: input.employeeId,
      },
    };
    return service.peakPayrollAPI
      .post("/api/Salary/UpdateStatement", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIServiceStatement(err.response));
  }
}
export default new StatementService();
